import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { icons } from '@assets/icons';

export const FlexCenterSetCss = css`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ImportWrapper = styled.div`
  ${FlexCenterSetCss};
  position: relative;
  & label[for='txt-upload-input'] {
    ${FlexCenterSetCss};
    width: 150px;
    height: 40px;
    cursor: pointer;
    border: 1px solid #e0e0e0;
    box-sizing: border-box;
    border-radius: 0 5px 5px 0;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;

    ::before {
      content: '';
      width: 10px;
      height: 10px;
      background: url(${icons.import_plus});
      background-size: 10px 10px;
      color: #7fe200;
      margin: 0 5px;
    }
  }
  & input[type='file'] {
    position: absolute;
    width: 1px;
    height: 1px;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    border: 0;
  }
  & input ~ div[data-type='validate'] {
    display: none;
  }
  & input[data-invalid]:not([data-invalid='']) {
    border-color: #ff4c4c !important;
  }

  & input[data-invalid]:is([data-invalid='']),
  & input:focus,
  & input:active {
    outline: none;
    border-color: #7fe200 !important;
  }
  & input[data-invalid$='true' i]:invalid {
    border-color: #ff4c4c !important;
    position: relative;
    & ~ div[data-type='validate'] {
      display: block !important;
      position: absolute;
      left: 0;
      top: 100%;
      width: 100%;
      &::after {
        content: 'Please enter the Code.';
        color: #ff4c4c;
        font-size: 14px;
        position: absolute;
        top: 100%;
        width: 100%;
      }
    }
  }
`;

export const LicenseKeyInput = styled.input`
  height: 40px;
  width: calc(100% - 40px);
  box-sizing: border-box;
  border: 1px solid #e0e0e0;
  border-right-width: 0;
  border-radius: 5px 0 0 5px;
  outline: unset;
  padding: 0 20px;
  &:focus-visible,
  &:focus-visible + label {
    border: 1px solid #7fe200;
    outline: unset;
  }
  &:focus-visible {
    border-right-width: 0;
  }
`;
export const ImportButton = styled.input``;
